import { ChangeDetectionStrategy, Component, input } from '@angular/core';

/** Slot visual no interactivo: marca dónde irá foto/video real. */
@Component({
  selector: 'app-website-media-slot',
  standalone: true,
  template: `
    <div
      class="media-slot"
      [class.media-slot--hero]="variant() === 'hero'"
      [class.media-slot--wide]="variant() === 'wide'"
      [class.media-slot--square]="variant() === 'square'"
      role="img"
      [attr.aria-label]="label() + (hint() ? '. ' + hint() : '')"
    >
      <span class="media-slot__tag">{{ label() }}</span>
      @if (hint()) {
        <p class="media-slot__hint">{{ hint() }}</p>
      }
    </div>
  `,
  styles: [
    `
      .media-slot {
        pointer-events: none;
        user-select: none;
        position: relative;
        display: grid;
        place-items: center;
        gap: 0.45rem;
        min-height: 11rem;
        padding: 1.5rem;
        border-radius: 1rem;
        background: color-mix(in srgb, #c8e400 6%, #151a22);
        border: 1px solid color-mix(in srgb, #c8e400 16%, transparent);
        color: color-mix(in srgb, #ffffff 70%, #c8e400);
        text-align: center;
      }

      .media-slot--hero {
        min-height: min(48vh, 26rem);
        border-radius: 0;
        border-left: none;
        border-right: none;
        background:
          radial-gradient(ellipse 50% 40% at 50% 40%, color-mix(in srgb, #c8e400 12%, transparent), transparent 70%),
          #12161d;
      }

      .media-slot--wide {
        min-height: 14rem;
        aspect-ratio: 16 / 10;
      }

      .media-slot--square {
        aspect-ratio: 1;
        min-height: 0;
      }

      .media-slot__tag {
        font-size: 0.68rem;
        font-weight: 700;
        letter-spacing: 0.1em;
        text-transform: uppercase;
        color: color-mix(in srgb, #c8e400 75%, #fff);
      }

      .media-slot__hint {
        margin: 0;
        max-width: 32ch;
        font-size: 0.82rem;
        line-height: 1.45;
        color: color-mix(in srgb, #ffffff 52%, transparent);
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WebsiteMediaSlotComponent {
  readonly label = input.required<string>();
  readonly hint = input<string>('');
  readonly variant = input<'default' | 'hero' | 'wide' | 'square'>('default');
}
